import { render, staticRenderFns } from "./td-secondary.vue?vue&type=template&id=746548fa&scoped=true"
import script from "./td-secondary.vue?vue&type=script&lang=js"
export * from "./td-secondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746548fa",
  null
  
)

export default component.exports